import { IconButton, SvgIconWrapper, Typography } from 'lighthouse';
import { CrossNoneOutlineMdSVG } from 'lighthouse-icons';

import { SafeImage } from '@/widgets/SafeImage';

import { GenerateFilePreviewUrl } from '@/utilities/GenerateFilePreviewUrl';

import { StoreProductsModalHeaderProps } from './models';

import { TickCircle } from 'iconsax-react';

export const StoreProductsModalHeader = ({ onClose, storeName, storeUuid }: StoreProductsModalHeaderProps) => {
    return (
        <header className='shrink-0 bg-white'>
            <div className='flex items-center justify-between gap-3 px-4 pb-3 pt-3'>
                <div className='flex min-w-0 items-center gap-2'>
                    <span className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-success/10 text-success'>
                        <TickCircle size={18} color='currentColor' variant='Bold' aria-hidden />
                    </span>
                    <Typography
                        id='store-products-modal-title'
                        variant='subtitle2'
                        component='p'
                        color='blackHighEmphasis'
                        className='min-w-0 font-bold leading-6'>
                        محصول شما به سبد خرید اضافه شد
                    </Typography>
                </div>

                <IconButton type='button' onClick={onClose} size='small' aria-label='بستن' className='!p-0'>
                    <SvgIconWrapper icon={CrossNoneOutlineMdSVG} size='md' color='blackMediumEmphasis' />
                </IconButton>
            </div>

            <div className='mx-4 mb-3 flex items-center gap-3 rounded-lg border border-primary/15 bg-primary/[0.05] p-3'>
                <figure className='m-0 h-12 w-12 shrink-0 overflow-hidden rounded-lg border border-solid border-N200 bg-white'>
                    <SafeImage
                        src={
                            GenerateFilePreviewUrl({
                                attachableId: storeUuid,
                                attachment: 'STORE',
                                type: 'LOGO',
                                isPrimary: true,
                                sortOrder: 0
                            }).src
                        }
                        alt={storeName}
                        fallback='/images/vendor/vendor_profile_default.png'
                        className='h-full w-full object-contain'
                        width={48}
                        height={48}
                    />
                </figure>
                <div className='min-w-0 flex-1'>
                    <Typography variant='body2' component='p' color='blackHighEmphasis' className='text-right text-sm font-semibold leading-6'>
                        خریدت رو کامل‌تر کن
                    </Typography>
                    <Typography variant='caption' component='p' color='blackMediumEmphasis' className='mt-1 text-right leading-5'>
                        محصولات بیشتر از فروشگاه <span className='font-semibold text-blackHighEmphasis'>{storeName}</span>
                    </Typography>
                </div>
            </div>
        </header>
    );
};
